export default __webpack_public_path__ + "static/media/LoginLogo.158e7baf.svg";